import React from 'react';
import CycleReportShell from '../../components/cycleReport/CycleReportShell';
import { SALE_LANES } from '../../utils/cycleReportHelper';

// Sale cycle: QT → SO → DC → SI/NSI (+ SR/NSR returns) → Receipt.
const SaleCycleReport = () => (
  <CycleReportShell
    title="Sale Cycle"
    lanes={SALE_LANES}
    partyType="customer"
    partyCollectionName="customers"
    partyNameField="companyName"
    defaultStaleAfterDays={30}
  />
);

export default SaleCycleReport;
